import { login } from "./login/loginActions";
//export { buyIcecream } from "./iceCream/iceCreamActions";
export default login;
